<template>
  <div id="shouyilive">
    <div class="topmoney whiteB">
      <span>直播收益(元)：</span>
      <span class="money">{{ data.live }}</span>
    </div>

    <!--列表信息-->
    <ul class="whiteB">
      <li class="title">
        <span>时间</span>
        <span>直播时长</span>
        <span>收益</span>
      </li>
      <li v-for="(n, index) in list" :key="index">
        <span>{{ n.time }}</span>
        <span>{{ n.duration }}</span>
        <span>{{ n.money }}</span>
      </li>
    </ul>

    <!--空白-->
    <blank message="暂无信息" v-if="blank"></blank>
    <!--空白文本组件-->
    <blanktext v-if="blankText"></blanktext>
    <!--去往提现的按钮-->
    <tixianbutton :money="data.surplus"></tixianbutton>
  </div>
</template>

<script>
import tixianbutton from "./tixianbutton";
import blank from "./blank";
import blanktext from "./blankText";

export default {
  name: "shouyilive",
  components: {
    tixianbutton,
    blank,
    blanktext
  },
  data() {
    return {
      blank: false,
      blankText: false,
      list: [],
      page: 1,
      ismore: true,
      data: [],
      scroll: true //当前页面是否允许加载等多
    };
  },
  methods: {
    //下拉加载更多 */
    getMore() {
      var _this = this;
      window.onscroll = function() {
        if (!_this.scroll) {
          return;
        }
        var fall =
          _this.$tool.getScrollHeight() -
          (_this.$tool.getScrollTop() + _this.$tool.getWindowHeight());
        var is = fall <= 50;
        if (is && _this.ismore) {
          _this.page++;
          _this.getList(_this.see);
        }
      };
    },
    //获取列表
    getList() {
      let _this = this;
      let data = {
        start: _this.page
      };
      this.$jsonp(this.$apis("liveshouyi"), data, res => {
        //判断是否有数据
        _this.data = res.data.data;
        let ls = res.data.data.data;
        if (res.data.data.total != "0") {
          //有记录
          if (ls.length > 0) {
            if (_this.page == 1) {
              _this.getMore();
            }
            _this.ismore = true;
            for (var i = 0; i < ls.length; i++) {
              _this.list.push(ls[i]);
            }
          } else {
            //记录请求完
            _this.ismore = false;
            _this.blankText = true;
          }
        } else {
          //没有任何记录
          _this.ismore = false;
          _this.blank = true;
        }
      });
    }
  },
  mounted: function() {
    this.$emit("showOhidden", false, 3);
    this.$tool.setTitle("直播收益");
    this.getList();
  },
  beforeDestroy() {
    this.scroll = false;
  }
};
</script>

<style scoped>
#shouyilive {
  margin-bottom: 3rem;
}
.topmoney {
  padding: 0.7rem;
  font-size: 15px;
  margin-bottom: 0.5rem;
}
.topmoney * {
  vertical-align: middle;
}
.money {
  font-weight: 600;
}

li {
  padding: 0.5rem 0;
  font-size: 14px;
  border-bottom: 1px solid #f4f4f4;
}
.title {
  font-size: 14px;
}
li span {
  display: inline-block;
  width: 33.3%;
  text-align: center;
}
</style>
